import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { migApi, errMsg, label } from "./lib";

const STATUSES = ["not_applicable", "quote_needed", "approved", "completed"];

// Assisted-migration metadata (PUT /migration). Never bills the customer.
export function MigrationMeta({ cid, batch, statuses = STATUSES, onSaved }) {
  const [f, setF] = useState({ billable_service: !!batch.billable_service, migration_service_status: batch.migration_service_status || "not_applicable", migration_service_note: batch.migration_service_note || "", reference: batch.reference || "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const b = await migApi.migration(cid, batch.id, f); toast.success("Assisted migration details saved"); onSaved?.(b); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-border p-3 space-y-2" data-testid="mig-meta">
      <p className="text-xs font-semibold">Assisted migration service (internal)</p>
      <div className="grid sm:grid-cols-2 gap-2">
        <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={f.billable_service} onChange={(e) => setF({ ...f, billable_service: e.target.checked })} data-testid="mig-meta-billable" /> Billable service</label>
        <div><Label className="text-xs">Service status</Label>
          <select value={f.migration_service_status} onChange={(e) => setF({ ...f, migration_service_status: e.target.value })} className="h-8 w-full rounded-md border border-input bg-background px-2 text-xs capitalize" data-testid="mig-meta-status">{statuses.map((s) => <option key={s} value={s}>{label(s)}</option>)}</select></div>
        <div><Label className="text-xs">Reference</Label><Input value={f.reference} onChange={(e) => setF({ ...f, reference: e.target.value })} className="h-8 text-xs" placeholder="Quote / invoice ref" data-testid="mig-meta-reference" /></div>
        <div><Label className="text-xs">Service note</Label><Input value={f.migration_service_note} onChange={(e) => setF({ ...f, migration_service_note: e.target.value })} className="h-8 text-xs" data-testid="mig-meta-note" /></div>
      </div>
      <div className="flex items-center justify-between gap-2"><p className="text-[11px] text-muted-foreground">Labeling only. Stripe is never charged from here.</p><Button size="sm" className="h-7 text-xs" disabled={busy} onClick={save} data-testid="mig-meta-save">Save</Button></div>
    </div>
  );
}
